<template>
  <div class="rewardSetting">
    <div>
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="form.program" placeholder="奖励方案"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.type" placeholder="方案类型">
            <el-option
              v-for="item in form.typeData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small">{{$t('common.search')}}</el-button>
          <el-button @click="tradingRewardPop" type="primary" size="small">代理交易奖励方案设置</el-button>
          <el-button @click="tierBonusPop" type="primary" size="small">代理层级奖励方案设置</el-button>
        </el-form-item>
      </el-form>
      <el-table border :data="tableData" tooltip-effect="dark" style="width: 100%">
        <el-table-column :prop="item.id" :label="item.name" v-for="item in tableNav" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column :label="$t('common.handle')" width="340">
          <template slot-scope="scope">
            <el-button size="mini" type="primary">详情</el-button>
            <el-button size="mini" type="primary">{{$t('common.edit')}}</el-button>
            <el-button size="mini" type="primary">{{$t('common.cancle')}}</el-button>
            <el-button size="mini" type="danger">审批</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="交易奖励设置" :visible.sync="isTradingRewardPop">
      <el-form label-width="180px">
        <el-form-item label="方案名称">
          <el-input v-model="tradingRewardForm.name"></el-input>
        </el-form-item>
        <el-form-item label="支持平台">
          <el-checkbox v-model="tradingRewardForm.platform">TRADE</el-checkbox>
        </el-form-item>
        <el-form-item label="一级代理奖励比例">
          <el-input v-model="tradingRewardForm.level1"></el-input>
        </el-form-item>
        <el-form-item label="二级代理奖励比例">
          <el-input v-model="tradingRewardForm.level2"></el-input>
        </el-form-item>
        <el-form-item label="三级代理奖励比例">
          <el-input v-model="tradingRewardForm.level3"></el-input>
        </el-form-item>
      </el-form>
      <div class="flexCenter">
        <el-button type="primary">{{$t('common.ok')}}</el-button>
        <el-button @click="isTradingRewardPop=false">{{$t('common.cancle')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog title="层级额外奖励设置" :visible.sync="isTierBonusPop">
      <el-form label-width="180px">
        <el-form-item label="方案名称">
          <el-input v-model="tradingRewardForm.name"></el-input>
        </el-form-item>
        <el-form-item label="支持平台">
          <el-checkbox v-model="tradingRewardForm.platform">TRADE</el-checkbox>
        </el-form-item>
        <el-form-item label="交易金额">
          <el-input v-model="tradingRewardForm.minMoney" type="number" class="input_width"></el-input>
          <span>至</span>
          <el-input v-model="tradingRewardForm.maxMoney" type="number" class="input_width"></el-input>
          <span>元，额外奖励交易金额比例</span>
          <el-input v-model="tradingRewardForm.program" type="number" class="input_width"></el-input>
          <span>%</span>
        </el-form-item>
      </el-form>
      <div class="flexCenter">
        <el-button type="primary">{{$t('common.ok')}}</el-button>
        <el-button @click="isTierBonusPop=false">{{$t('common.cancle')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'rewardSetting',
    data() {
      return {
        form: {
          program: '',
          type: '',
          typeData: [
            { name: '一级代理交易奖励方案名称', id: 0 }
          ]
        },
        tableNav: [
          { name: '方案名称', id: 'planName' },
          { name: '方案类型', id: 'planType' },
          { name: '支持平台', id: 'tradePlatform' },
          { name: '创建时间', id: 'createTime' },
          { name: '创建人', id: 'operator' },
          { name: '状态', id: 'status' },
          { name: '审批时间', id: 'auditTime' },
          { name: '审批人', id: 'auditor' }
        ],
        tableData: [],
        isTradingRewardPop: false, //弹窗是否显示
        tradingRewardForm: {
          name: '',
          platform: '',
          level1: '',
          level2: '',
          level3: ''
        },
        isTierBonusPop: false, //弹窗是否显示
        tierBonusForm: {
          name: '',
          platform: '',
          minMoney: '',
          maxMoney: '',
          program: ''
        }
      }
    },
    methods: {
      tradingRewardPop() {
        this.isTradingRewardPop = !this.isTradingRewardPop
      },
      tierBonusPop() {
        this.isTierBonusPop = !this.isTierBonusPop
      }
    }
  }
</script>

<style lang="scss" scoped>
  .rewardSetting {
    margin: 20px;

    .flexCenter {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .input_width {
      width: 100px;
    }
  }
</style>
